import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { isArrayLike } from '../../utils/isArrayLike';

export class AggregateTransform extends BaseTransform {
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		let response: any = queryResponse;
		const { aggregateTransformOptions } = this.options;
		if (queryResponse && isArrayLike(queryResponse)) {
			const { type = 'sum', key } = aggregateTransformOptions;
			const values = key ? queryResponse.map(i => i[key]) : queryResponse;
			const total = values.reduce((acc, value) => {
				return acc + value;
			}, 0);
			const count = values.length;
			if (type === 'sum') {
				response = total;
			}
			if (type === 'count') {
				response = count;
			}
			if (type === 'average') {
				response = count > 0 ? total/count : 0;
			}
		}
		return response;
	}
}